var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5689 30.3736C15.8032 32.8044 18.7752 34.0069 22.0734 34.2618C25.3716 34.5166 28.6403 33.5122 31.2142 31.4529C33.7881 29.3937 35.4736 26.4344 35.9277 23.1775C36.3817 19.9206 35.5701 16.611 33.6581 13.9224C31.7461 11.2337 28.8775 9.36822 25.6361 8.70559C22.3947 8.04297 19.0244 8.63305 16.2111 10.3557C13.3979 12.0784 11.3532 14.8041 10.4933 17.978C9.63351 21.152 10.0231 24.5355 11.5829 27.4398L13.2243 26.4125C11.9168 23.978 11.8032 21.1873 12.524 18.5267C13.2447 15.8661 14.9587 13.5813 17.317 12.1372C19.6752 10.6932 22.5005 10.1985 25.2176 10.754C27.9347 11.3094 30.3394 12.8732 31.9422 15.127C33.5449 17.3808 34.2252 20.1551 33.8446 22.8853C33.464 25.6154 32.0511 28.0961 29.8935 29.8223C27.7359 31.5485 24.9958 32.3904 22.2311 32.1768C19.4663 31.9631 17.3164 31.0737 15.4436 29.036L13.5689 30.3736Z",
    fill: "#43927C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.118 11.8029C19.8315 12.4002 17.7545 13.6086 16.1117 15.2971L17.6213 16.7497C18.9983 15.3344 20.7393 14.3216 22.6558 13.8209L22.118 11.8029Z",
    fill: "#DFAF7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.0552 39.2879L12.8137 25.9063L13.1754 26.2684L-7.1951 40.9975L-11.0536 43.9898L-11.0552 39.2879Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/manager-icon.b6c00d7bcc84950e75e89734ab952d04.svg";
export { ForwardRef as ReactComponent };